module.exports = __webpack_public_path__ + "ed6f8cf8779a024b32f7e0634bc850e1.pdf";